
import {mpx} from '@didi/es-mpx-creator'
import { TRAIN_ID_TYPE_LIST } from '@/api/urls'

export const idTypeList = (data) => {
  return mpx.$http.post(
    TRAIN_ID_TYPE_LIST, 
    { data }
  )
}
